import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { LINKS } from '@/constants/links';
import { Button } from '@/components/buttons';
import { CareerBoxes } from '@/components/boxes';
import { Headline } from '@/components/typography';
import { Job } from '@/types/job';
interface CareerProps {
  jobs: Job[];
  jobsCount: string;
}
export function Career(t0) {
  const $ = _c(15);
  const {
    jobs,
    jobsCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["career"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== jobsCount || $[2] !== t) {
    t2 = <Headline as="h2" variant="h4" className="mb-6 text-white lg:mb-8"><Trans t={t} i18nKey="career.title">{jobsCount}</Trans></Headline>;
    $[1] = jobsCount;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== jobs) {
    t3 = <CareerBoxes items={jobs} />;
    $[4] = jobs;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = LINKS();
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = t4.careerList;
  let t6;
  if ($[7] !== t) {
    t6 = t("career.cta");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <Button to={t5} testId="careerCareerList" analyticsParam="careerCareerList" size="lg" variant="primary" align="center" className="mt-12 lg:mt-16">{t6}</Button>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t7) {
    t8 = <div className="relative z-10 mx-auto max-w-192 px-4">{t2}{t3}{t7}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}